<template lang="pug">
  el-card.box-processo(shadow="hover")
    h1.titulo(v-if="!processo") Distribuir Processo
    div.box-titulo(v-else)
      el-button.botao-voltar(
            type="primary"
            @click="voltar"
          )
            span.center
              i.fas.fa-chevron-left
      span.span-titulo(v-if="processo") {{ `Processo ${numProcesso}:` }}
    el-row.caixa-pesquisa(:gutter="30", v-if="!processo")
      el-col(:span="8")
          app-label(label="Digite o N° do Processo:")
          el-input(
            placeholder="N° do Processo",
            class="input-with-select",
            v-model="numProcesso"
          )
            el-button.color-default(
              slot="append",
              icon="el-icon-search",
              id='botao-pesquisar',
              @click="pesquisar"
            )
    el-row.caixa-pesquisa(:gutter="30", v-else)
      el-col.col-principal(:span="24")
        card-processo(
          :idProcesso="processo.id",
          :nomeInteressado="processo.nomeRazaoSocialInteressado",
          :statusProcesso="processo.status",
          :numeroProcesso="processo.numeroProcesso",
          :cpfCnpjInteressado="processo.cpfCnpjInteressado",
          :setorProcesso="processo.setor",
          :opcoesAcoes="true",
          :numeroProtocolo="processo.numeroProtocolo",
          :tipoCodigoProcesso="processo.tipo.codigo",
          :usuario="processo.usuario"
        )
        div(v-if="processo && processo.status !== 'ARQUIVADO' && processo.status !== 'FINALIZADO'")
          app-label(label="Motivo da mudança:")
          app-editor-texto.editor-texto(
            @onTextChange="onTextChange",
            v-model="mensagem",
            :disabled="processo.status === 'ARQUIVADO' || processo.status === 'FINALIZADO'",
            placeholder="Digite o motivo da mudança"
            ref="editorTexto",
          )
          app-radios-tramitacao(
            v-if="tarefa && tarefa.acoes && tarefa.acoes.length",
            :radios="tarefa.acoes",
            @changeRadio="changeRadio",
            :isDecisao="false",
            :radioInicial="acao",
            :isModuloMoverProcesso="true"
          )
      el-col.btn-box
        el-button.btn(
            type="primary"
            @click="distribuirProcesso"
            :disabled="(tarefa && tarefa.acoes && tarefa.acoes.length === 0) || (processo.status.toUpperCase() === 'ARQUIVADO' || processo.status.toUpperCase() === 'FINALIZADO')"
          )
            span.center
              b Mover &nbsp
              i.fas.fa-chevron-right
</template>
<script>
import AppLabel from '@/components/AppLabel'
import {buscarProcesso, buscarTarefa, distribuirProcesso} from '@/utils/manutencao'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao'
import AppEditorTexto from '@/components/AppEditorTexto'
import CardProcesso from './components/CardProcesso.vue'
export default {
  components: {
    AppLabel,
    AppRadiosTramitacao,
    AppEditorTexto,
    CardProcesso
  },
  data () {
    return {
      numProcesso: '',
      mensagem: '',
      processo: null,
      tarefa: null,
      acao: 'TESTE'
    }
  },

  mixins: [
    AppNotificacao
  ],

  methods: {
    async pesquisar () {
      this.acao = null
      this.tarefa = null
      if (!this.numProcesso || this.numProcesso.trim() === '') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Preencha o campo N° do Processo')
      else {
        const response = await buscarProcesso(this.numProcesso.trim())
        const tarefaResponse = await buscarTarefa(response.id)
        if (response && tarefaResponse) {
          this.processo = response
          this.tarefa = {name: tarefaResponse.nameKeyCurrentTask, acoes: tarefaResponse.nextDecisions.map(d => ({nome: d.label ? d.label : d.codigo, valor: d.codigo}))}
        } else {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            'Erro ao buscar o Processo, verifique o N° do Processo')
        }
      }
    },
    onTextChange (text) {
      this.mensagem = text
    },
    changeRadio (value) {
      this.acao = value.acao
    },
    async distribuirProcesso () {
      const mensagem = this.mensagem.replace(/<[\w\s="-:;]+>*|&nbsp;*|<\/\w+>/g, '').replace(/( ){2,}/g, '$1').trim()
      if (!this.acao) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Selecione a tramitação')
      else if (mensagem.length < 10) this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'O campo "Motivo da mudança" deve estar preenchido com no minímo 10 caracteres')
      else {
        const response = await distribuirProcesso(this.acao, this.tarefa.name, this.tarefa.acoes.length, this.numProcesso, this.processo.id, this.mensagem)
        if (response.toUpperCase() !== 'OK') this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Erro ao distribuir processo, verifique sua conexão')
        else {
          await this.pesquisar()
          this.mensagem = ''
          this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo distribuído')
        }
      }
    },
    voltar () {
      this.processo = null
      this.numProcesso = ''
      this.mensagem = ''
      this.tarefa = null
      this.acao = null
    }
  }
}
</script>
<style lang="scss" scoped>
    $font-size-small: 12px;

    .color-default {
      color: #009d64 !important;
      font-size: 16px;
    }
    .caixa-pesquisa {
      margin-bottom: 10px;
    }
    .titulo {
      margin-top: 0;
    }
    .span-titulo {
      margin-top: 0;
      margin-bottom: 3px;
      font-size: 32px;
      margin-left: 20px;
    }
    .box-processo {
      min-width: 720px;
      padding-left: 3px;
      padding-right: 3px;
    }
    .span-style {
      font-weight: normal;
    }
    .botao-voltar {
      width: 30px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .center {
      display: flex;
      text-align: center;
      justify-content: center;
      align-items: center;
    }
    .box-titulo {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .col-principal {
      min-width: 685px;
    }
    .btn {
      margin-top: 15px;
    }
    .btn-box {
      display: flex;
      justify-content: flex-end;
    }
    .editor-texto {
      margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/screens/manutencao/DistribuirProcessos.vue